import React from "react";
import "./Legal.css";
import SEO from "../../Components/SEO";

function TermsOfUse() {
  return (
    <>
      <SEO
        title="Shipping Terms Of Use"
        description="Lutology Terms Of Use Policy"
      />
      <main
        className="legal-page"
        role="main"
        aria-label="Lutology Terms of Use"
      >
        <h1>Terms of Use</h1>
        <p className="legal-meta">Last updated: 2025</p>

        <p>
          Welcome to Lutology™. By accessing or using this Site, you agree to
          these Terms of Use.
        </p>

        <h2>1. General</h2>
        <p>
          This Site is owned and operated by Lutology™. All content is protected
          and may not be reused without permission.
        </p>

        <h2>2. Use of the Site</h2>
        <p>You may use the Site for personal, non-commercial purposes only.</p>

        <h2>3. Products</h2>
        <p>
          Products are cosmetic and not intended to diagnose, treat or cure any
          medical condition.
        </p>

        <h2>4. Prices & Payments</h2>
        <p>Prices and availability may change without notice.</p>

        <h2>5. Shipping</h2>
        <p>
          For shipping details, please review our{" "}
          <strong>Shipping Policy</strong>.
        </p>

        <h2>6. Returns & Refunds</h2>
        <p>
          Return and refund guidelines are described in our{" "}
          <strong>Refund Policy</strong>.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          Lutology™ is not liable for indirect or consequential damages related
          to the use of the Site or products.
        </p>

        <h2>8. User Representations</h2>
        <p>
          By using this Site, you confirm that the information you provide is
          accurate and that you are legally permitted to enter agreements.
        </p>

        <h2>9. Changes</h2>
        <p>
          We may update these Terms from time to time. Continued use indicates
          acceptance.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These terms are governed by the laws of the State of Israel unless
          consumer protection laws require otherwise.
        </p>

        <h2>11. Contact</h2>
        <p>
          For any questions regarding these Terms, please{" "}
          <a href="/contact" className="legal-link">
            reach us via our Contact page
          </a>
          .
        </p>
      </main>
    </>
  );
}

export default TermsOfUse;
